
jQuery(function($){

    function stickyFooter(){

        var view = $(window),

            wrapper = $("#wrapper"),

            container = $("#container"),

            main = $("#main"),

            footer = $("#footer"),

            viewHeight = view.height(),

            wrapperHeight = wrapper.height(),
            
            footerHeight = footer.height(),

            mainOffset = main.offset(),							// offset.top = Headerhöhe

            headFootHeight = mainOffset.top + footerHeight,		// vorhandene Header und Footerhöhe

            minContentHeight = viewHeight - headFootHeight;		// Minimalhöhe des #container, um das Browserfenster auszufüllen


        if ( wrapperHeight < viewHeight ) {						// erst feuern, falls #wrapper kleiner als Browserfenster

        	container.css("min-height", minContentHeight);
        }

        footer.addClass("loaded");								// Anti-Flash-Effect, benötigt sticky_footer.css / sticky_footer.less

    }

    $(window).on('load', function(){								// Erst wenn ALLE Elemente "gefüllt" sind, kann man die Werte auslesen

    	stickyFooter();

    });

});